import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { Icon } from '@vectord/components';
import classNames from 'classnames';

import DeleteMenteeModuleButton from '../DeleteMenteeModuleButton';
import styles from './MenteeModulesTableRow.module.scss';
import TableCell from 'components/TableCell';
import TableRow from 'components/TableRow';
import UpdateMenteeModuleStatusSelect from '../UpdateMenteeModuleStatusSelect';
import AddMenteeModuleButton from '../AddMenteeModuleButton';

function MenteeModulesTableRow({ menteeModule, index }) {
  const { academy_module: academyModule, order } = menteeModule;
  const { name } = academyModule;

  return (
    <Draggable
      draggableId={String(menteeModule.id)}
      index={index}
    >
      {({ draggableProps, dragHandleProps, innerRef }, { isDragging }) => (
        <TableRow
          ref={innerRef}
          className={classNames({
            [styles.rowDragActive]: isDragging,
          })}
          {...draggableProps}
        >
          <TableCell>
            <Icon
              name="hamburger"
              {...dragHandleProps}
            />
          </TableCell>
          <TableCell>{order}</TableCell>
          <TableCell>{name}</TableCell>
          <TableCell>
            <UpdateMenteeModuleStatusSelect menteeModule={menteeModule} />
          </TableCell>
          <TableCell>
            <AddMenteeModuleButton menteeModule={menteeModule} />
          </TableCell>
          <TableCell>
            <DeleteMenteeModuleButton menteeModule={menteeModule} />
          </TableCell>
        </TableRow>
      )}
    </Draggable>
  );
}

export default MenteeModulesTableRow;
